<template>
  <div id="app">
    <b-navbar toggleable="lg" type="light" variant="primary">
      <b-navbar-brand to="/">
        <img alt="Logo" src="./assets/logo-xs.png" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-main-collapse"></b-navbar-toggle>
      <b-collapse id="nav-main-collapse" is-nav>
        <b-navbar-nav class="w-100">
          <b-nav-item to="/" exact class="h4 my-0 mr-2 heading">Home</b-nav-item>
          <b-nav-item to="/schedule" class="h4 my-0 mr-2 heading">Program</b-nav-item>
          <b-nav-item to="/seniors" class="h4 my-0 mr-2 heading">Seniors</b-nav-item>
          <b-nav-item to="/credits" class="h4 my-0 mr-2 heading">Credits</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view />
    <div class="container">
      <footer class="pt-4 my-md-5 pt-md-5 border-top">
        <div class="row">
          <div class="col-5-lg col-sm">
            <h3 class="heading">Contact</h3>
            <div>Phone: <a href="tel://510-581-3262" class="cvpa-link">510-581-3262</a></div>
            <div>General Questions: <a href="mailto://cvpadance@gmail.com" class="cvpa-link">cvpadance@gmail.com</a></div>
            <div>Billing Inquiries: <a href="mailto://cvpa_acctg@yahoo.com" class="cvpa-link">cvpa_acctg@yahoo.com</a></div>
            <div class="mt-3">
              <div class="d-inline-block m-3"><img src="./assets/img/dance-masters-seal.webp"></div>
              <div class="d-inline-block m-3"><img src="./assets/img/adcc_affiliate.webp"></div>
            </div>
          </div>
          <div class="col-lg-7 text-right">
            <h3 class="heading">About CVPA</h3>
            Castro Valley Performing Arts is a family-oriented school that provides quality dance training in a positive, nurturing, and enthusiastic environment. Through classes, performances and unique educational experiences, our dancers learn essential life skills such as teamwork, responsibility, leadership, and time management. Whether dancing for recreation or seeking a professional career in the arts, CVPA strives to create a rewarding experience for every student. We are passionate about dance and about sharing our love for this art form with the next generation. For more information, please visit <a href="http://www.castrovalleyperformingarts.com" target="_blank" class="cvpa-link">www.castrovalleyperformingarts.com</a>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-lg text-center">
            <div class="mb-3">
              <router-link to="/past-years" class="cvpa-link">Past Galas &amp; Recitals</router-link>
            </div>
            <div class="d-inline-lg h3">
              <a href="https://cvpaboutique.com/" title="CVPA Boutique" target="_blank" class="text-dark"><b-icon-bag-fill class="mr-2"></b-icon-bag-fill></a>
              <a href="https://www.facebook.com/CastroValleyPerformingArts/" title="Facebook" target="_blank" class="text-dark"><b-icon-facebook class="mr-2"></b-icon-facebook></a>
              <a href="https://www.youtube.com/channel/UCsyMsk2x_4PSJ30fQgfsteQ" title="YouTube" target="_blank" class="text-dark"><b-icon-youtube class="mr-2"></b-icon-youtube></a>
              <a href="https://www.instagram.com/castrovalleyperformingarts/" title="Instagram" target="_blank" class="text-dark"><b-icon-instagram class="mr-2"></b-icon-instagram></a>
            </div>
            <div class="small mr-2">© 2021 - 2027 Copyright Castro Valley Performing Arts.</div>
            <div class="small mr-2">Made with <b-icon-heart-fill class="text-danger"></b-icon-heart-fill> by ClassCitizen.</div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/theme.css";
import "./assets/css/site.css";
import Vue from "vue";
import { 
  NavbarPlugin,
  FormPlugin,
  ButtonPlugin,
  FormInputPlugin,
  IconsPlugin,
  TabsPlugin,
  CardPlugin,
  CarouselPlugin,
  ImagePlugin
} from "bootstrap-vue";

Vue.use(NavbarPlugin);
Vue.use(FormPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormInputPlugin);
Vue.use(IconsPlugin)
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(CarouselPlugin);
Vue.use(ImagePlugin);

export default {};
</script>


<style lang="scss">
</style>
